import React from 'react';
import Column from '../column';
import Divider from '../divider';
import Text from '../text';
import styles from './styles.module.scss';

var PageTitle = function PageTitle(_ref) {
  var altFont = _ref.altFont,
      title = _ref.title,
      subtitle = _ref.subtitle,
      hasDivider = _ref.hasDivider,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'title-xl' : _ref$size;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "page-title"
  }, /*#__PURE__*/React.createElement(Column, {
    pl: 0.5,
    pr: 0.5
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    size: size,
    weight: "extra-bold",
    altFont: altFont
  }, title, subtitle && /*#__PURE__*/React.createElement(Text, {
    as: "span",
    weight: "regular",
    size: "subtitle-3xl",
    className: styles.subtitle,
    altFont: altFont
  }, subtitle))), hasDivider && /*#__PURE__*/React.createElement(Column, {
    mt: 0.5,
    mb: 0.5
  }, /*#__PURE__*/React.createElement(Divider, null)));
};

export default PageTitle;